// # #############################################
// # Title : Graphs
// # Authors : Shubham, Anoop, Dhruv
// # Date : 15th October 2019
// # Last Modified : August 2019
// # Version : 19.10.03
// # Description :  Graphs for agent behaviour pannel under analytics tab in run and open scenario view
// # ############################################

import React, { Component } from "react";
import Windrose from "./Windrose.js";
import FixedColumnChart from "./FixedColumnChart.js";
import ActivityCount from "./ActivityCount.js";
import StreamGraph from "./StreamGraph.js";
import SankeyChart from "../components/SankeyChart";
import Revenue from "./Revenue";
import PricingDetails from "./PricingDetails";
import "../css/DataScienceTabs.css";
import "../css/SyncSparks.css";
import GlobalEvents from "../utils/global-events"
import TempGraph from './TemperatureTrend'
import SparklinesComponent from "./SparkLines";






class Graphs extends Component {

    state = {
        selected: "agentBehaviour",
        simEnd: 0,
        withRespectTo: "yourBrand",
        data: [ //Template to initialize data inflow for the brand index bar chart
            {
                "Zip": "35801",
                "State": "Connecticut",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {},
                "temperature": 0
            },
            {
                "Zip": "99501",
                "State": "Florida",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {},
                "temperature": 0
            },
            {

                "Zip": "85001",
                "State": "Illinois",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {},
                "temperature": 0
            },
            {
                "Zip": "72201",
                "State": "Kentucky",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {},
                "temperature": 0
            },
            {
                "Zip": "94203",
                "State": "Michigan",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {},
                "temperature": 0
            },
            {
                "Zip": "90001",
                "State": "Minnesota",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {},
                "temperature": 0
            },
            {
                "Zip": "90209",
                "State": "New Jersey",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {},
                "temperature": 0
            },
            {
                "Zip": "80201",
                "State": "Pennsylvania",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {},
                "temperature": 0
            },
            {
                "Zip": "06101",
                "State": "Washington",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {},
                "temperature": 0
            },
            {
                "Zip": "19901",
                "State": "Wisconsin",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {},
                "temperature": 0
            }
        ]
    };

    changeProps(el) {
        this.setState({
            selected: el,
            simCompleteStatus: false
        });
    }

    // handleChange = event => {
    //     this.setState({ withRespectTo: event.target.value });
    // };

    deleteChild() {
        let e = document.querySelector("#sparklines");

        //e.firstElementChild can be used. 
        if (e) {
            let child = e.lastElementChild;
            while (child) {
                e.removeChild(child);
                child = e.lastElementChild;
            }
        }
    }

    displayTrendGraphs() {
        const self = this;
        return (
            <div style={{ borderBottom: "0px solid #D2DBE0" }}>
                <div>
                    <TempGraph 
                    fromWhere = "graphs"
                    subscribe_ns={self.props.subscribe_ns} />
                </div>
                <SparklinesComponent
                    subscribe_ns={self.props.subscribe_ns}
                    unsubscribe_ns={self.props.unsubscribe_ns}
                />
            </div>
        )
    }

    getGraphs() {
        if (sessionStorage.simStarted !== "true") {
            return (
                <div
                    style={{
                        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                        color: "#4f412e",
                        fontSize: "1.2vw",
                        textAlign: "center",
                        margin: "50% 0",
                        background: "whitesmoke"
                    }}
                >
                    Start simulation in order to view results
        </div>
            );
        } else {
            const self = this;

            if (self.state.selected === "agentBehaviour") {
                return (
                    <div style={{ background: "whitesmoke" }}>
                        <div style={{ borderBottom: "1px solid #D2DBE0" }}>
                            <Windrose
                                key="activity_count_wind_rose"
                                subscribe_ns={self.props.subscribe_ns}
                                ns_value="activity_count_wind_rose"
                                unsubscribe_ns={self.props.unsubscribe_ns}
                            />
                        </div>
                        <div style={{ borderBottom: "1px solid #D2DBE0" }}>
                            <ActivityCount
                                key="drinking_moment_by_beverage_category"
                                subscribe_ns={self.props.subscribe_ns}
                                ns_value="drinking_moment_by_beverage_category"
                                unsubscribe_ns={self.props.unsubscribe_ns}
                            />
                        </div>
                    </div>)
            }
            else if (self.state.selected === "comsumptionPattern") {
                return (
                    <div style={{ background: "whitesmoke" }}>
                        <div style={{ borderBottom: "1px solid #D2DBE0" }}>
                            <StreamGraph
                                key="drinking_moment_count_by_hour_high"
                                subscribe_ns={self.props.subscribe_ns}
                                ns_value="drinking_moment_count_by_hour_high"
                                unsubscribe_ns={self.props.unsubscribe_ns}
                                title="Drinking Moments by hour of the day"
                            />
                        </div>
                        <div style={{ borderBottom: "1px solid #D2DBE0" }}>
                            <StreamGraph
                                key="beverage_category_count_by_hour_high"
                                subscribe_ns={self.props.subscribe_ns}
                                ns_value="beverage_category_count_by_hour_high"
                                unsubscribe_ns={self.props.unsubscribe_ns}
                                title="Beverage Category by hour of the day"
                            />
                        </div>
                        <div style={{ borderBottom: "1px solid #D2DBE0" }}>
                            <SankeyChart
                                key="beverage_category_vs_drinking_moment"
                                subscribe_ns={self.props.subscribe_ns}
                                ns_value="beverage_category_vs_drinking_moment"
                                unsubscribe_ns={self.props.unsubscribe_ns}
                            />
                        </div>
                    </div>
                )
            }
            else if (self.state.selected === "salesAndPromotion") {
                return (
                    <div style={{ background: "whitesmoke" }}>
                        <div style={{ borderBottom: "1px solid #D2DBE0" }}>
                            <SankeyChart
                                key="brand_choice_vs_segment"
                                subscribe_ns={self.props.subscribe_ns}
                                ns_value="brand_choice_vs_segment"
                                unsubscribe_ns={self.props.unsubscribe_ns}
                            />
                        </div>
                        <div style={{ borderBottom: "1px solid #D2DBE0" }}>
                            <SankeyChart
                                key="brand_choice_vs_drinking_moment"
                                subscribe_ns={self.props.subscribe_ns}
                                ns_value="brand_choice_vs_drinking_moment"
                                unsubscribe_ns={self.props.unsubscribe_ns}
                            />
                        </div>
                        <div style={{ borderBottom: "1px solid #D2DBE0" }}>
                            <Revenue
                                key="brand_choice_by_day_high"
                                subscribe_ns={self.props.subscribe_ns}
                                ns_value="brand_choice_by_day_high"
                                unsubscribe_ns={self.props.unsubscribe_ns}
                                graph="brand_choice"
                            />
                        </div>
                        <div style={{ borderBottom: "1px solid #D2DBE0" }}>
                            <Revenue
                                key="brand_revenue_by_day_high"
                                subscribe_ns={self.props.subscribe_ns}
                                ns_value="brand_revenue_by_day_high"
                                unsubscribe_ns={self.props.unsubscribe_ns}
                                graph="brand_revenue"
                            />
                        </div>
                        <div style={{ borderBottom: "1px solid #D2DBE0" }}>
                            <Revenue
                                key="cumulative_penetration_by_day"
                                subscribe_ns={self.props.subscribe_ns}
                                ns_value="cumulative_penetration_by_day"
                                unsubscribe_ns={self.props.unsubscribe_ns}
                                graph="brand_penetration"
                            />
                        </div>
                        <div style={{ borderBottom: "1px solid #D2DBE0" }}>
                            <FixedColumnChart
                                key="channel_ad_reach"
                                subscribe_ns={self.props.subscribe_ns}
                                ns_value="channel_ad_reach"
                                unsubscribe_ns={self.props.unsubscribe_ns}
                            />
                        </div>
                    </div>)
            }
            else if (self.state.selected === "simulationTrends") {
                return (
                    <div style={{ background: "whitesmoke" }}>
                        {sessionStorage.simCompleted === 'true' ? this.displayTrendGraphs() :
                            sessionStorage.currentTick === "0" ?
                                <div id={"loaderContainer"}>
                                    <div class="lds-facebook"><div></div><div></div><div></div></div>
                                </div>
                                :
                                this.displayTrendGraphs()
                        }
                    </div>)
            }
            else {
                return (
                    <div>
                        <PricingDetails subscribe_ns={self.props.subscribe_ns} />
                    </div>
                )
            }
        }

    }


    componentDidUpdate() {

        if (
            sessionStorage.getItem("simCompleted") === "true" &&
            this.state.simEnd === 0 &&
            this.refs[`summaryEnd`]
        ) {
            this.setState({
                simEnd: 1,
                selected: "summaryEnd"
            });
        }
    }

    componentDidMount() {

        GlobalEvents.on('simdata', (data) => {
            this.setState({
                data: data
            })
        })

        if (
            sessionStorage.getItem("simCompleted") === "true" &&
            this.state.simEnd === 0 &&
            this.refs[`summaryEnd`]
        ) {
            this.setState({
                simEnd: 1,
                selected: "summaryEnd"
            });
        }

        GlobalEvents.on("showendinfo", () => {
            this.setState({
                simCompleteStatus: true
            })
        });
    }

    render() {
        return (
            <React.Fragment>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        overflow: "none",
                        height: "100%",
                        color: "#4f412e"
                    }}
                >
                    <div
                        style={{
                            margin: "2%",
                            marginBottom: "0%",
                            marginTop: "0%",
                            display: "flex",
                            textAlign: "center",
                            overflow: "none"
                        }}
                    >
                        {sessionStorage.getItem("simCompleted") === "true" ? (
                            <div
                                className={
                                    this.state.selected === "summaryEnd"
                                        ? "card_element_selected"
                                        : "card_element"
                                }
                                ref="summaryEnd"
                                title={"Summary"}
                                onClick={this.changeProps.bind(this, "summaryEnd")}
                            >
                                <img
                                    src="summaryend.svg"
                                    alt="Avatar"
                                    style={{ width: "2vw" }}
                                />
                                <div className="text_container"> Summary </div>
                            </div>

                        ) : null}
                        <div
                            className={
                                this.state.selected === "agentBehaviour"
                                    ? "card_element_selected"
                                    : "card_element"
                            }
                            ref="agentBehaviour"
                            onClick={this.changeProps.bind(this, "agentBehaviour")}
                            title={"Agent Behaviour"}
                            style={{ borderTopLeftRadius: "0" }}
                        >
                            <img
                                src="agentBehaviour.svg"
                                alt="Avatar"
                                style={{ width: "2vw" }}
                            />
                            <div className="text_container"> Agent Behaviour </div>
                        </div>
                        <div
                            className={
                                this.state.selected === "comsumptionPattern"
                                    ? "card_element_selected"
                                    : "card_element"
                            }
                            ref="comsumptionPattern"
                            title={"Comsumption Pattern"}
                            onClick={this.changeProps.bind(this, "comsumptionPattern")}
                        >
                            <img
                                src="comsumptionPattern.svg"
                                alt="Avatar"
                                style={{ width: "2vw" }}
                            />
                            <div className="text_container"> Consumption Pattern </div>
                        </div>
                        <div
                            className={
                                this.state.selected === "salesAndPromotion"
                                    ? "card_element_selected"
                                    : "card_element"
                            }
                            ref="salesAndPromotion"
                            title={"Sales & Promotion"}
                            onClick={this.changeProps.bind(this, "salesAndPromotion")}
                        >
                            <img
                                src="salesAndPromotion.svg"
                                alt="Avatar"
                                style={{ width: "2vw" }}
                            />
                            <div className="text_container"> Sales & Promotion </div>
                        </div>
                        <div
                            className={
                                this.state.selected === "simulationTrends"
                                    ? "card_element_selected"
                                    : "card_element"
                            }
                            ref="simulationTrends"
                            title={"Scenario Dynamics"}
                            onClick={this.changeProps.bind(this, "simulationTrends")}
                        >
                            <img
                                src="infographic.svg"
                                alt="Avatar"
                                style={{ width: "2vw" }}
                            />
                            <div className="text_container"> Scenario Dynamics </div>
                        </div>

                    </div>
                    <div key={this.props.countryWidth} className="graphsLayout">{this.getGraphs()}</div>
                </div>
            </React.Fragment>
        );
    }
}

export default Graphs;
